import netsForgotPassword from './nets-forgot-password';
import moduleConfig from './module-config';

export default angular
  .module('app.forgotPassword', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsForgotPassword', netsForgotPassword);
